import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import Logo from "@/components/Logo";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH

export default function AuthCallback() {
  const nav = useNavigate();
  const { refresh } = useAuth();
  const processed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    (async () => {
      const hash = window.location.hash || "";
      const match = hash.match(/session_id=([^&]+)/);
      if (!match) {
        setError("No session_id in URL. Open the login page and try again.");
        return;
      }
      const sessionId = decodeURIComponent(match[1]);
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sessionId });
        localStorage.setItem("ndis_hub_token", data.token);
        // strip the hash so reloads don't re-process
        window.history.replaceState(null, "", "/");
        await refresh();
        toast.success(`Welcome, ${data.user.full_name?.split(" ")[0]}!`);
        nav("/", { replace: true });
      } catch (e) {
        setError(formatApiError(e));
      }
    })();
  }, [nav, refresh]);

  return (
    <div className="min-h-screen grid place-items-center p-6" data-testid="auth-callback">
      <div className="text-center space-y-4">
        <Logo />
        {error ? (
          <>
            <p className="text-destructive font-bold max-w-md">{error}</p>
            <a href="/login" className="underline text-sm font-bold">Back to login</a>
          </>
        ) : (
          <>
            <div className="w-10 h-10 rounded-full border-4 border-client border-t-transparent animate-spin mx-auto" />
            <p className="text-sm font-bold text-muted-foreground">Signing you in with Google…</p>
          </>
        )}
      </div>
    </div>
  );
}
